import * as yup from "yup";


const LendingPurposeSchema = yup.object().shape({
    openToExploring: yup.string().min(2).required('Answer Required'),
    governmentBackedLoans: yup.string().min(2).required('Answer Required'),
    activeConcerns: yup.string().min(2).required('Answer Required'),
    seekingLoan: yup.string().min(2).required('Answer Required'),
    reasonforconcerns: yup.string(),
    loanType: yup.string(),
    loanamount: yup.string()
});


export default LendingPurposeSchema;